import inStyleguidist from "./inStyleguidist";
export default () => {
  return (
    inStyleguidist() || window.location.host === "localhost:8321" || window.location.host.indexOf("ngrok-free.app") > -1
  );
};
